var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocial04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.953125 11.582V22.557H6.2955V10.6771V7.36386H0.953125V11.582Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6154 7.43364C15.4323 7.43364 13.9595 8.41167 13.3437 9.35469H13.1499V7.36386H9.21875V10.4682V22.557H13.6539V15.1877C13.6539 13.2105 13.837 11.3039 16.1677 11.3039C18.5105 11.3039 18.4924 13.5586 18.4924 15.3267V22.557H22.9276V14.3801C22.9276 13.6002 22.9499 12.814 22.8697 12.1456C22.5349 9.2782 21.3385 7.43364 17.6154 7.43364Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76919 0C2.36314 0 1.22461 1.18329 1.22461 2.64508C1.22461 4.10698 2.36314 5.28995 3.76919 5.28995C5.17535 5.28995 6.31338 4.10698 6.31338 2.64508C6.31328 1.18329 5.17525 0 3.76919 0Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial04);
export default __webpack_public_path__ + "static/media/social-04.abeb9853e0d8dc7e676565f0fa9ef03b.svg";
export { ForwardRef as ReactComponent };